import EventEmitter from "events";
import type { TValidators, IValidator, TErrorer } from "./Validators"
import Validators from "./Validators";

export default class FormControl<T> extends EventEmitter implements IValidator {
    private _name : string;
    private _validators : TValidators<T>
    private _valid = false
    private _dirty = false
    private _touched = false

    constructor(name:string, validators:TValidators<T>, startValue?:T) {
        super()
        this._name = name
        this._validators = validators
        this._valid = startValue ? this.validate(startValue)==null : false
    }

    get name() { return this._name}
    get valid(){ return this._valid}
    get invalid(){ return !this.valid && (this.dirty || this.touched)}
    get dirty() { return this._dirty}
    get touched(){ return this._touched}

    validate(value:T){
        for(let validator of this._validators){
            const result = validator(value)
            if (result && typeof(result)=="string") return result
            else if (result===false) return validator
        }
        return null
    }
    errorer(value:T, errorer:TErrorer<T>|undefined) {
        const error = this.validate(value)
        if (error) {
            if  (typeof(error)=="string") return error
            else if (errorer) return errorer(value, error)
            else return Validators.errorer(this._name, value, error)
        }
        else return `Invalid ${this._name}`
    }
    update(value:any, silent:boolean=false) {
        if (typeof(value)=="undefined") return this
        this.setDirty(true)
        return this.setValid(this.validate(value)==null)
    }
    setValid(v:boolean, silent:boolean=false){
        if (this._valid!=v) {
            this._valid =  v
            return silent ? this : this._refresh()
        }
        else return this
    }
    setDirty(v:boolean, silent:boolean=false){
        if (this._dirty!=v) {
            this._dirty =  v
            return silent ? this : this._refresh()
        }
        else return this
    }
    setTouched(v:boolean, silent:boolean=false){
        if (this._touched!=v) {
            this._touched =  v
            return silent ? this : this._refresh()
        }
        else return this
    }
    private _refresh(){
        this.emit("refresh", this)
        return this
    }
}
